import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class OperationRequest {
    @ApiProperty({ enum: Object.values(OperationTypeEnum) })
    @IsNotEmpty()
    operationType:OperationTypeEnum;
    @ApiProperty()
    @IsNotEmpty()
    plantId:number
}